export const WORKLOAD_PAGE_LIMIT = 20;
export const WORKLOAD_REFRESH_INTERVAL_MS = 30_000;
export const TOP_BUCKET_LIMIT = 15;

export { METRICS_TIME_RANGES as RANGE_PRESETS } from '@/lib/metrics-time-range';
export type { MetricsTimeRangeKey as RangeKey } from '@/lib/metrics-time-range';

export type ChartMetric = 'processingLoad' | 'requestRate' | 'averageDurationMs';
export const WORKLOAD_CHART_METRICS: ChartMetric[] = ['processingLoad', 'requestRate', 'averageDurationMs'];
export type GroupingDimension = 'username' | 'resourceType' | 'action' | 'apiLabel';

export const GROUPING_DIMENSIONS: Array<{ key: GroupingDimension; label: string }> = [
  { key: 'username', label: 'User' },
  { key: 'resourceType', label: 'ResourceType' },
  { key: 'action', label: 'Action' },
  { key: 'apiLabel', label: 'APILabel' },
];

export const ALL_GROUPING_DIMENSIONS = GROUPING_DIMENSIONS.map((dimension) => dimension.key);

export interface ChartPairConfig {
  id: number;
  dimensions: GroupingDimension[];
  metrics: ChartMetric[];
  clients: string[] | null;
}

export type RequestLatencyMetric =
  | 'totalRequests'
  | 'processingSharePercent'
  | 'averageDurationMs'
  | 'histogramP50Ms'
  | 'histogramP95Ms'
  | 'histogramP99Ms'
  | 'slowerThan250Percent'
  | 'slowerThan1000Percent';

export interface WorkloadInsightState {
  dimensions: GroupingDimension[];
  latencyDimensions: GroupingDimension[];
  latencyMetric: RequestLatencyMetric;
}

export const DEFAULT_WORKLOAD_INSIGHT_STATE: WorkloadInsightState = {
  dimensions: ['username'],
  latencyDimensions: ['resourceType', 'action', 'apiLabel'],
  latencyMetric: 'averageDurationMs',
};

export interface WorkloadSeries {
  key: string;
  label: string;
  legendParts: Array<{ key: GroupingDimension; label: string; value: string }>;
  totalProcessingTimeNs: number;
  totalRequests: number;
  timestamps: number[];
  processingLoad: number[];
  requestRate: number[];
  averageDurationMs: number[];
}

export interface WorkloadGroupSummary {
  key: string;
  label: string;
  groupValues: Partial<Record<GroupingDimension, string>>;
  totalProcessingTimeNs: number;
  totalRequests: number;
  averageDurationMs: number;
  processingSharePercent: number;
  requestSharePercent: number;
}

export interface WorkloadRequestTimeSummary extends WorkloadGroupSummary {
  p95DurationMs: number;
  p99DurationMs: number;
  sampledIntervals: number;
}

export interface WorkloadShareSeries {
  key: string;
  label: string;
  timestamps: number[];
  percentages: number[];
}

export interface WorkloadHeatmap {
  users: string[];
  apiLabels: string[];
  processingSeconds: number[][];
}

export interface WorkloadHealthPoint {
  timestamp: number;
  activeUsers: number;
  aggregates: number;
  droppedRecords: number;
}
